import style from "./CertificateLink.module.css";

import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Icon from "@/ui/icon/Icon";

function CertificateLink({ certificateID = 0 }) {
	const { t } = useTranslation();

	return (
		<Link to={`/certificates/${certificateID}`} className={style.button}>
			<span>{t("courses:certificate.open")}</span>
			<div className={style.icoHolder}>
				<span className={style.defaultIcon}>
					<Icon icon="fa-file-certificate" />
				</span>
				<span className={style.hoverIcon}>
					<Icon icon="fa-arrow-right-long" />
				</span>
			</div>
		</Link>
	);
}

export default CertificateLink;
